// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","272":"component---src-pages-notices-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"b3171ced52673c05566a","272":"9c4052f423bd2646e411","691":"583f1af65f5c61a425d0"}[chunkId] + ".js";
};